"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.create");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.set-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.trim");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _native = _interopRequireDefault(require("@emotion/native"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _deepEqual = _interopRequireDefault(require("deep-equal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Input =
/*#__PURE__*/
_native["default"].TextInput(function (_ref) {
  var theme = _ref.theme;
  return {
    borderWidth: 1,
    borderRadius: 2,
    fontSize: 13,
    padding: 5,
    margin: 10,
    borderColor: theme.borderColor,
    color: theme.labelColor
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy9PYmplY3QuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS2MiLCJmaWxlIjoiLi4vLi4vc3JjL3R5cGVzL09iamVjdC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IGRlZXBFcXVhbCBmcm9tICdkZWVwLWVxdWFsJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vbmF0aXZlJztcblxuY29uc3QgSW5wdXQgPSBzdHlsZWQuVGV4dElucHV0KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJvcmRlcldpZHRoOiAxLFxuICBib3JkZXJSYWRpdXM6IDIsXG4gIGZvbnRTaXplOiAxMyxcbiAgcGFkZGluZzogNSxcbiAgbWFyZ2luOiAxMCxcbiAgYm9yZGVyQ29sb3I6IHRoZW1lLmJvcmRlckNvbG9yLFxuICBjb2xvcjogdGhlbWUubGFiZWxDb2xvcixcbn0pKTtcblxuY2xhc3MgT2JqZWN0VHlwZSBleHRlbmRzIFJlYWN0LkNvbXBvbmVudCB7XG4gIGNvbnN0cnVjdG9yKC4uLmFyZ3MpIHtcbiAgICBzdXBlciguLi5hcmdzKTtcbiAgICB0aGlzLnN0YXRlID0ge307XG4gIH1cblxuICBnZXRKU09OU3RyaW5nKCkge1xuICAgIGNvbnN0IHsganNvbiwganNvblN0cmluZyB9ID0gdGhpcy5zdGF0ZTtcbiAgICBjb25zdCB7IGtub2IgfSA9IHRoaXMucHJvcHM7XG5cbiAgICAvLyBJZiB0aGVyZSBpcyBhbiBlcnJvciBpbiB0aGUgSlNPTiwgd2UgbmVlZCB0byBnaXZlIHRoYXQgZXJyb3JlZCBKU09OLlxuICAgIGlmICh0aGlzLmZhaWxlZCkgcmV0dXJuIGpzb25TdHJpbmc7XG5cbiAgICAvLyBJZiB0aGUgZWRpdG9yIHZhbHVlIGFuZCB0aGUga25vYiB2YWx1ZSBpcyB0aGUgc2FtZSwgd2UgbmVlZCB0byByZXR1cm4gdGhlXG4gICAgLy8gZWRpdG9yIHZhbHVlIGFzIGl0IGFsbG93IHVzZXIgdG8gYWRkIG5ldyBmaWVsZHMgdG8gdGhlIEpTT04uXG4gICAgaWYgKGRlZXBFcXVhbChqc29uLCBrbm9iLnZhbHVlKSkgcmV0dXJuIGpzb25TdHJpbmc7XG5cbiAgICAvLyBJZiB0aGUga25vYidzIHZhbHVlIGlzIGRpZmZlcmVudCBmcm9tIHRoZSBlZGl0b3IsIGl0IHNlZW1zIGxpa2VcbiAgICAvLyB0aGVyZSdzIGEgb3V0c2lkZSBjaGFuZ2UgYW5kIHdlIG5lZWQgdG8gZ2V0IHRoYXQuXG4gICAgcmV0dXJuIEpTT04uc3RyaW5naWZ5KGtub2IudmFsdWUsIG51bGwsIDIpO1xuICB9XG5cbiAgaGFuZGxlQ2hhbmdlID0gdmFsdWUgPT4ge1xuICAgIGNvbnN0IHsgb25DaGFuZ2UgfSA9IHRoaXMucHJvcHM7XG5cbiAgICBjb25zdCB3aXRoUmVwbGFjZWRRdW90ZXMgPSB2YWx1ZVxuICAgICAgLnJlcGxhY2UoL1tcXHUyMDE4XFx1MjAxOV0vZywgXCInXCIpXG4gICAgICAucmVwbGFjZSgvW1xcdTIwMUNcXHUyMDFEXS9nLCAnXCInKTtcblxuICAgIGNvbnN0IG5ld1N0YXRlID0ge1xuICAgICAganNvblN0cmluZzogd2l0aFJlcGxhY2VkUXVvdGVzLFxuICAgIH07XG5cbiAgICB0cnkge1xuICAgICAgbmV3U3RhdGUuanNvbiA9IEpTT04ucGFyc2Uod2l0aFJlcGxhY2VkUXVvdGVzLnRyaW0oKSk7XG5cbiAgICAgIG9uQ2hhbmdlKG5ld1N0YXRlLmpzb24pO1xuICAgICAgdGhpcy5mYWlsZWQgPSBmYWxzZTtcbiAgICB9IGNhdGNoIChlcnIpIHtcbiAgICAgIHRoaXMuZmFpbGVkID0gdHJ1ZTtcbiAgICB9XG5cbiAgICB0aGlzLnNldFN0YXRlKG5ld1N0YXRlKTtcbiAgfTtcblxuICByZW5kZXIoKSB7XG4gICAgY29uc3QgeyBrbm9iIH0gPSB0aGlzLnByb3BzO1xuICAgIGNvbnN0IGpzb25TdHJpbmcgPSB0aGlzLmdldEpTT05TdHJpbmcoKTtcbiAgICBjb25zdCBleHRyYVN0eWxlID0ge307XG5cbiAgICBpZiAodGhpcy5mYWlsZWQpIHtcbiAgICAgIGV4dHJhU3R5bGUuYm9yZGVyV2lkdGggPSAxO1xuICAgICAgZXh0cmFTdHlsZS5ib3JkZXJDb2xvciA9ICcjZmFkZGRkJztcbiAgICAgIGV4dHJhU3R5bGUuYmFja2dyb3VuZENvbG9yID0gJyNmZmY1ZjUnO1xuICAgIH1cblxuICAgIHJldHVybiAoXG4gICAgICA8SW5wdXRcbiAgICAgICAgaWQ9e2tub2IubmFtZX1cbiAgICAgICAgc3R5bGU9e2V4dHJhU3R5bGV9XG4gICAgICAgIHZhbHVlPXtqc29uU3RyaW5nfVxuICAgICAgICBvbkNoYW5nZVRleHQ9e3RoaXMuaGFuZGxlQ2hhbmdlfVxuICAgICAgICBtdWx0aWxpbmVcbiAgICAgICAgYXV0b0NhcGl0YWxpemU9XCJub25lXCJcbiAgICAgICAgdW5kZXJsaW5lQ29sb3JBbmRyb2lkPVwidHJhbnNwYXJlbnRcIlxuICAgICAgLz5cbiAgICApO1xuICB9XG59XG5cbk9iamVjdFR5cGUuZGVmYXVsdFByb3BzID0ge1xuICBrbm9iOiB7fSxcbiAgb25DaGFuZ2U6IHZhbHVlID0+IHZhbHVlLFxufTtcblxuT2JqZWN0VHlwZS5wcm9wVHlwZXMgPSB7XG4gIGtub2I6IFByb3BUeXBlcy5zaGFwZSh7XG4gICAgbmFtZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgICB2YWx1ZTogUHJvcFR5cGVzLm9uZU9mVHlwZShbUHJvcFR5cGVzLm9iamVjdCwgUHJvcFR5cGVzLmFycmF5XSksXG4gIH0pLFxuICBvbkNoYW5nZTogUHJvcFR5cGVzLmZ1bmMsXG59O1xuXG5PYmplY3RUeXBlLnNlcmlhbGl6ZSA9IG9iamVjdCA9PiBKU09OLnN0cmluZ2lmeShvYmplY3QpO1xuT2JqZWN0VHlwZS5kZXNlcmlhbGl6ZSA9IHZhbHVlID0+ICh2YWx1ZSA/IEpTT04ucGFyc2UodmFsdWUpIDoge30pO1xuXG5leHBvcnQgZGVmYXVsdCBPYmplY3RUeXBlO1xuIl19 */");

var ObjectType =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ObjectType, _React$Component);

  function ObjectType() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ObjectType);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ObjectType)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleChange = function (value) {
      var onChange = _this.props.onChange;
      var withReplacedQuotes = value.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"');
      var newState = {
        jsonString: withReplacedQuotes
      };

      try {
        newState.json = JSON.parse(withReplacedQuotes.trim());
        onChange(newState.json);
        _this.failed = false;
      } catch (err) {
        _this.failed = true;
      }

      _this.setState(newState);
    };

    _this.state = {};
    return _this;
  }

  _createClass(ObjectType, [{
    key: "getJSONString",
    value: function getJSONString() {
      var _this$state = this.state,
          json = _this$state.json,
          jsonString = _this$state.jsonString;
      var knob = this.props.knob; // If there is an error in the JSON, we need to give that errored JSON.

      if (this.failed) return jsonString; // If the editor value and the knob value is the same, we need to return the
      // editor value as it allow user to add new fields to the JSON.

      if ((0, _deepEqual["default"])(json, knob.value)) return jsonString; // If the knob's value is different from the editor, it seems like
      // there's a outside change and we need to get that.

      return JSON.stringify(knob.value, null, 2);
    }
  }, {
    key: "render",
    value: function render() {
      var knob = this.props.knob;
      var jsonString = this.getJSONString();
      var extraStyle = {};

      if (this.failed) {
        extraStyle.borderWidth = 1;
        extraStyle.borderColor = '#fadddd';
        extraStyle.backgroundColor = '#fff5f5';
      }

      return _react["default"].createElement(Input, {
        id: knob.name,
        style: extraStyle,
        value: jsonString,
        onChangeText: this.handleChange,
        multiline: true,
        autoCapitalize: "none",
        underlineColorAndroid: "transparent"
      });
    }
  }]);

  return ObjectType;
}(_react["default"].Component);

ObjectType.defaultProps = {
  knob: {},
  onChange: function onChange(value) {
    return value;
  }
};
ObjectType.propTypes = {
  knob: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    value: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array])
  }),
  onChange: _propTypes["default"].func
};

ObjectType.serialize = function (object) {
  return JSON.stringify(object);
};

ObjectType.deserialize = function (value) {
  return value ? JSON.parse(value) : {};
};

var _default = ObjectType;
exports["default"] = _default;